"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculationCaseResultPropertyInfo = exports.calculationCasePropertyInfo = exports.configPropertyInfo = exports.newCalculationCasePvs = exports.initialCalculationCasePvs = exports.initialConfigPvs = void 0;
const property_1 = require("@genesys/property");
const property_2 = require("@genesys/property");
const known_properties_1 = require("./known-properties");
const summerCalcCasePvsString = `
    ${known_properties_1.name}="Summer";
    ${known_properties_1.highTemperatureStageInUse}=0;
    ${known_properties_1.highTemperatureStageCondenserInletTemperature}=95:Celsius;
    ${known_properties_1.highTemperatureStageCondenserOutletTemperature}=115:Celsius;
    ${known_properties_1.highTemperatureStageHeatingCapacityRequirement}=100:KiloWatt;
    ${known_properties_1.highTemperatureStageCondenserPipeLength}=25:Meter;
    ${known_properties_1.lowTemperatureStageCondenserInletTemperature}=20:Celsius;
    ${known_properties_1.lowTemperatureStageCondenserOutletTemperature}=65:Celsius;
    ${known_properties_1.lowTemperatureStageCondenserPipeLength}=25.1:Meter;
    ${known_properties_1.lowTemperatureStageEvaporatorInletTemperature}=8:Celsius;
    ${known_properties_1.lowTemperatureStageEvaporatorOutletTemperature}=5:Celsius;
    ${known_properties_1.lowTemperatureStageEvaporatorPipeLength}=25:Meter;
    ${known_properties_1.lowTemperatureStageHeatingCapacityRequirement}=100:KiloWatt;
    ${known_properties_1.lowTemperatureStageCoolingCapacityRequirement}=100:KiloWatt;
    ${known_properties_1.wetAirDumpingStreamOutletTemperature}=43:Celsius;`;
const newCalcCasePvsString = `
    ${known_properties_1.name}="";
    ${known_properties_1.highTemperatureStageInUse}=0;
    ${known_properties_1.highTemperatureStageCondenserInletTemperature}=0:Celsius;
    ${known_properties_1.highTemperatureStageCondenserOutletTemperature}=0:Celsius;
    ${known_properties_1.highTemperatureStageHeatingCapacityRequirement}=0:KiloWatt;
    ${known_properties_1.highTemperatureStageCondenserPipeLength}=0:Meter;
    ${known_properties_1.lowTemperatureStageCondenserInletTemperature}=0:Celsius;
    ${known_properties_1.lowTemperatureStageCondenserOutletTemperature}=0:Celsius;
    ${known_properties_1.lowTemperatureStageCondenserPipeLength}=0:Meter;
    ${known_properties_1.lowTemperatureStageEvaporatorInletTemperature}=0:Celsius;
    ${known_properties_1.lowTemperatureStageEvaporatorOutletTemperature}=0:Celsius;
    ${known_properties_1.lowTemperatureStageEvaporatorPipeLength}=0:Meter;
    ${known_properties_1.lowTemperatureStageHeatingCapacityRequirement}=0:KiloWatt;
    ${known_properties_1.lowTemperatureStageCoolingCapacityRequirement}=0:KiloWatt;
    ${known_properties_1.wetAirDumpingStreamOutletTemperature}=0:Celsius;`;
const configPvsString = `
    ${known_properties_1.reference}="MP37615";
    ${known_properties_1.heatPumpConfigurationType}=1;
    ${known_properties_1.wetAirAvailableAsHeatSource}=0;
    ${known_properties_1.wetAirAvailableAsHeatSink}=0;
    ${known_properties_1.evaporatorFluidType}=0;
    ${known_properties_1.evaporatorFluidConcentration}=35:Percent;
    `;
exports.initialConfigPvs = property_1.PropertyValueSet.fromString(configPvsString.replace(/\s+/g, ""));
exports.initialCalculationCasePvs = property_1.PropertyValueSet.fromString(summerCalcCasePvsString.replace(/\s+/g, ""));
exports.newCalculationCasePvs = property_1.PropertyValueSet.fromString(newCalcCasePvsString.replace(/\s+/g, ""));
const discreteValues = [1, 2, 3, 4, 5].map(v => ({
    value: { type: "integer", value: v },
    sort_no: v,
    property_filter: property_2.PropertyFilter.Empty
}));
const booleanValues = [
    {
        value: { type: "integer", value: 0 },
        sort_no: 0,
        property_filter: property_2.PropertyFilter.Empty
    },
    {
        value: { type: "integer", value: 1 },
        sort_no: 1,
        property_filter: property_2.PropertyFilter.Empty
    }
];
exports.configPropertyInfo = [
    {
        name: known_properties_1.heatPumpConfigurationType,
        quantity: "Discrete",
        group: "mainselections",
        sort_no: 0,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: discreteValues
    },
    {
        name: known_properties_1.wetAirAvailableAsHeatSource,
        quantity: "Discrete",
        group: "mainselections",
        sort_no: 10,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: booleanValues
    },
    {
        name: known_properties_1.wetAirAvailableAsHeatSink,
        quantity: "Discrete",
        group: "mainselections",
        sort_no: 20,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: booleanValues
    },
    {
        name: known_properties_1.evaporatorFluidType,
        quantity: "Discrete",
        group: "mainselections",
        sort_no: 30,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: [
            {
                value: { type: "integer", value: 0 },
                sort_no: 0,
                property_filter: property_2.PropertyFilter.Empty
            },
            {
                value: { type: "integer", value: 1 },
                sort_no: 1,
                property_filter: property_2.PropertyFilter.Empty
            },
            {
                value: { type: "integer", value: 2 },
                sort_no: 2,
                property_filter: property_2.PropertyFilter.Empty
            },
            {
                value: { type: "integer", value: 3 },
                sort_no: 3,
                property_filter: property_2.PropertyFilter.Empty
            }
        ]
    },
    {
        name: known_properties_1.evaporatorFluidConcentration,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 40,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    }
];
exports.calculationCasePropertyInfo = [
    {
        name: known_properties_1.name,
        quantity: "Text",
        group: "mainselections",
        sort_no: 0,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageInUse,
        quantity: "Discrete",
        group: "mainselections",
        sort_no: 10,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: booleanValues
    },
    {
        name: known_properties_1.highTemperatureStageCondenserInletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 20,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageCondenserOutletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 30,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageHeatingCapacityRequirement,
        quantity: "Power",
        group: "mainselections",
        sort_no: 40,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageCondenserPipeLength,
        quantity: "Length",
        group: "mainselections",
        sort_no: 50,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCondenserInletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 60,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCondenserOutletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 70,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCondenserPipeLength,
        quantity: "Length",
        group: "mainselections",
        sort_no: 80,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageEvaporatorInletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 90,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageEvaporatorOutletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 100,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageEvaporatorPipeLength,
        quantity: "Length",
        group: "mainselections",
        sort_no: 110,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageHeatingCapacityRequirement,
        quantity: "Power",
        group: "mainselections",
        sort_no: 120,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCoolingCapacityRequirement,
        quantity: "Power",
        group: "mainselections",
        sort_no: 130,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.wetAirDumpingStreamOutletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 140,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    }
];
exports.calculationCaseResultPropertyInfo = [
    {
        name: known_properties_1.name,
        quantity: "Text",
        group: "mainselections",
        sort_no: 0,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.cop,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 1,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.wetAirCapacityRequired,
        quantity: "Power",
        group: "mainselections",
        sort_no: 2,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.wetAirDumpingStreamFlow,
        quantity: "MassFlow",
        group: "mainselections",
        sort_no: 3,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageCop,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 4,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageCirculationPumpPower,
        quantity: "Power",
        group: "mainselections",
        sort_no: 10,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageCondenserFlowRate,
        quantity: "MassFlow",
        group: "mainselections",
        sort_no: 20,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageElectricPowerConsumed,
        quantity: "Power",
        group: "mainselections",
        sort_no: 30,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageHeatingCapacity,
        quantity: "Power",
        group: "mainselections",
        sort_no: 40,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageLiquidOutletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 50,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageRelativeCapacity,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 60,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.highTemperatureStageRelativeCapacityAtMinimumSpeed,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 70,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCop,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 55,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCirculationPumpPower,
        quantity: "Power",
        group: "mainselections",
        sort_no: 80,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCondenserFlowRate,
        quantity: "MassFlow",
        group: "mainselections",
        sort_no: 90,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCondenserLiquidOutletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 100,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageCoolingCapacity,
        quantity: "Power",
        group: "mainselections",
        sort_no: 110,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageElectricPowerConsumed,
        quantity: "Power",
        group: "mainselections",
        sort_no: 120,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageEvaporatorFlowRate,
        quantity: "MassFlow",
        group: "mainselections",
        sort_no: 130,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageEvaporatorLiquidOutletTemperature,
        quantity: "Temperature",
        group: "mainselections",
        sort_no: 140,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageHeatingCapacity,
        quantity: "Power",
        group: "mainselections",
        sort_no: 150,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageRelativeCapacity,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 160,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    },
    {
        name: known_properties_1.lowTemperatureStageRelativeCapacityAtMinimumSpeed,
        quantity: "Dimensionless",
        group: "mainselections",
        sort_no: 170,
        validation_filter: property_2.PropertyFilter.Empty,
        visibility_filter: property_2.PropertyFilter.Empty,
        value: []
    }
];
//# sourceMappingURL=data.js.map